module.exports = function() {
  return new Worker(__webpack_public_path__ + "346d80301a7e90991999.worker.js");
};